export default __webpack_public_path__ + "static/animals-2940dc5b582e855fa526b53793b72b2c.png";